import * as React from "react";
const SvgPauseIconNoBg = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<rect x={3} y={1} width={3.42857} height={16} rx={1.71429} fill="#5B1DC2" /><rect x={12.1396} y={1} width={3.42857} height={16} rx={1.71429} fill="#5B1DC2" /></svg>;
export default SvgPauseIconNoBg;